<template>
    <transition name="fade2-right">
        <div class="MessageVueWrap" v-if="props.messageFlag">
            <div class="title">
                <div class="left">
                    <i class="icon-email-fill iconfont"></i> <span>消息通知</span>
                </div>
                <div class="right">
                    <router-link to="/message">查看更多</router-link>
                </div>
            </div>
            <div class="content">
                <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
                    <el-tab-pane label="全部" name="first">
                        <MessageListVue :messageArray="messageArray" @openMessageBox="openMessageBox" @changeMessageStatus="changeMessageStatus"></MessageListVue>
                    </el-tab-pane>
                    <el-tab-pane label="未读" name="second">
                        <MessageListVue :messageArray="messageFalseArray" @openMessageBox="openMessageBox"  @changeMessageStatus="changeMessageStatus"></MessageListVue>
                    </el-tab-pane>
                    <el-tab-pane label="已读" name="third">
                        <MessageListVue :messageArray="messageTrueArray" @openMessageBox="openMessageBox"></MessageListVue>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </transition>
</template>

<script setup>
import { ref,defineProps,defineEmits,onMounted, watch,inject } from 'vue';
import MessageListVue from '@/components/MessageList/MessageListVue.vue'
import message from '@/api/message'
const emit = defineEmits(['openMessageBox']);
const openMessageBox = (row) => {
    if(row.status === 1) {
        changeMessageStatus(row.id)
    }
    emit('openMessageBox', row)
}
const messageArray = ref([
    {
        id: 1,
        title: '任务分析成功',
        state: true,
        style: '系统消息',
        time: '2024 05-21 15:00:00'
    },{
        id: 2,
        title: '您发布的数据已审核通过',
        state: false,
        style: '系统消息',
        time: '2024 05-21 15:00:00'
    }
]);
const props = defineProps({
    messageFlag: Boolean
});
watch(props, (newValue) => {
    if(newValue.messageFlag) {
        getMessageData()
    }
});
const messageFalseArray = ref([])
const messageTrueArray = ref([])

for(let i in messageArray.value ) {
    if(messageArray.value[i].status === 2) {
        messageTrueArray.value.push(messageArray.value[i])
    } else {
        messageFalseArray.value.push(messageArray.value[i])
    }
}
const activeName = ref('first')

const handleClick = (tab, event) => {
  console.log(tab, event)
}
const getMessageData = () => {
    message.getMessageList({
        page: 1,
        limit: 9999,
        status: 0
    }).then(res=> {
        if(res.code ===0) {
            messageTrueArray.value = [];
            messageFalseArray.value = [];
            messageArray.value = res.data.list;
            for(let i in messageArray.value ) {
                if(messageArray.value[i].status === 2) {
                    messageTrueArray.value.push(messageArray.value[i])
                } else {
                    messageFalseArray.value.push(messageArray.value[i])
                }
            }
        }
    })
}
const getVueMessageCount = inject('getVueMessageCount');
const changeMessageStatus = (id) => {
    message.messageUpdateRead({
        ids: [id]
    }).then(res=> {
        if(res.code ===0) {
            getMessageData();
            getVueMessageCount();
        }
    })
}
onMounted(()=> {
    getMessageData()
})



</script>

<style lang="scss" scoped>
.MessageVueWrap {
    width: 100%;
    max-width: 400px;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    background: #fff;
    z-index: 9999;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding: 10px;
    will-change: right;
    animation: fadeIn 0.5s ease;
   
    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #999;

        .right {
            font-size: 12px;
            cursor: pointer;
            &:hover {
                scale: 1.05;
                transition: all 0.3s;
            }
            &:active {
                scale: 1;
            }

            a {
                color: #72767b;
                text-decoration: none;
            }
        }

        .left {
            span {
                font-size: 16px;
                color: #72767b;
                font-weight: bold;
            }
            i {
                color: #72767b;
            }
        }
    }

    .content {
        height: calc(100% - 22px);
    }
}

@keyframes fadeIn {
    from {
        right: -100%;
        opacity: 0;
    }
    to {
        right: 0;
        opacity: 1;
    }
}
.fade2-right-leave-active {
  transition: right 1s ease;
}

.fade2-right-leave-to {
  right: -100%;
}

</style>